import { cn } from '@/lib/utils';

const ORG_STATUS_LABEL: Record<string, string> = {
  InProgress: 'In Progress',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
  Pending: 'Pending',
  Partial: 'Partial',
  Cancelled: 'Cancelled',
};

const ORG_STATUS_CLASS: Record<string, string> = {
  InProgress: 'border-transparent bg-info text-info-foreground animate-pulse',
  Succeeded: 'border-transparent bg-success text-success-foreground',
  Failed: 'border-transparent bg-destructive text-destructive-foreground',
  Partial: 'border-transparent bg-warning text-warning-foreground',
  Pending: 'border-transparent bg-secondary text-secondary-foreground',
  Cancelled: 'text-foreground border-border',
};

interface OrgStatusBadgeProps {
  status: string;
}

export function OrgStatusBadge({ status }: OrgStatusBadgeProps) {
  const label = ORG_STATUS_LABEL[status] ?? status;
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold',
        ORG_STATUS_CLASS[status] ?? 'border-transparent bg-secondary text-secondary-foreground',
      )}
    >
      {label}
    </div>
  );
}
